import TextAnswer from '@/components/shared/answer-types/text/text.vue';
import OfficerForm from '../../components/officer-form/officer-form.vue';
import ResourceSvc from '@/services/resource.svc.js';
import { OFFICER_TYPES, MAX_ADDITIONAL_OFFICERS, DEFAULTS, createEmptyAdditionalOfficer } from '../../constants/club-registration-constants.js';

const resourceService = new ResourceSvc();

export default {
    name: 'OfficersSection',

    components: {
        'text-answer': TextAnswer,
        'officer-form': OfficerForm
    },

    props: {
        club: {
            type: Object,
            required: true
        },
        validation: {
            type: Object,
            required: true
        },
        isAdmin: {
            type: Boolean,
            default: false
        },
        readOnly: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            defaults: DEFAULTS,
            maxAdditionalOfficers: MAX_ADDITIONAL_OFFICERS,
            additionalOfficerInfos: {},
            additionalOfficerLoading: {},
            additionalOfficerTimers: {}
        };
    },

    computed: {
        localClub: {
            get() { return this.club; },
            set(value) { this.$emit('update:club', value); }
        },
        localValidation: {
            get() { return this.validation; },
            set(value) { this.$emit('update:validation', value); }
        },
        cmsUrl() {
            return process.env.url.manegement;
        },
        officerTypes() {
            return OFFICER_TYPES.map(officer => {
                // Handle conditional mandatory fields
                if (officer.conditionalOn === 'hasJuniorMembers') {
                    return {
                        ...officer,
                        isMandatory: this.localClub.hasJuniorMembers === true
                    };
                }
                return officer;
            });
        }
    },

    methods: {
        addAdditionalOfficer(event) {
            if (this.localClub.additionalOfficers.length < this.maxAdditionalOfficers) {
                this.localClub.additionalOfficers.push(createEmptyAdditionalOfficer());
            }
            if (event && event.target) {
                event.target.blur();
            }
        },

        removeAdditionalOfficer(index) {
            this.localClub.additionalOfficers.splice(index, 1);

            const newInfos = {};
            const newLoading = {};
            const newTimers = {};
            const remaining = this.localClub.additionalOfficers;
            for (let i = 0; i < remaining.length; i++) {
                const oldIndex = i >= index ? i + 1 : i;
                if (this.additionalOfficerInfos.hasOwnProperty(oldIndex)) {
                    newInfos[i] = this.additionalOfficerInfos[oldIndex];
                }
                if (this.additionalOfficerLoading.hasOwnProperty(oldIndex)) {
                    newLoading[i] = this.additionalOfficerLoading[oldIndex];
                }
                if (this.additionalOfficerTimers.hasOwnProperty(oldIndex)) {
                    newTimers[i] = this.additionalOfficerTimers[oldIndex];
                }
            }
            if (this.additionalOfficerTimers[index]) {
                clearTimeout(this.additionalOfficerTimers[index]);
            }
            this.additionalOfficerInfos = newInfos;
            this.additionalOfficerLoading = newLoading;
            this.additionalOfficerTimers = newTimers;
        },

        lookupAdditionalOfficer(index) {
            const officer = this.localClub.additionalOfficers[index];
            if (!officer || !officer.memberNo || String(officer.memberNo).trim().length < 5) {
                this.$set(this.additionalOfficerInfos, index, null);
                return;
            }

            this.$set(this.additionalOfficerLoading, index, true);
            const self = this;
            resourceService.getMemberByLoginOrTiID(String(officer.memberNo).trim())
                .then(function (response) {
                    if (response && response.body && response.body.isSuccess && response.body.outputData) {
                        const data = response.body.outputData;
                        self.$set(self.additionalOfficerInfos, index, {
                            fullName: (data['First Name'] || '') + ' ' + (data['Last Name'] || ''),
                            email: data['Email'] || '',
                            tiNumber: data['TI Number'] || officer.memberNo
                        });
                    } else {
                        self.$set(self.additionalOfficerInfos, index, null);
                    }
                })
                .catch(function () {
                    self.$set(self.additionalOfficerInfos, index, null);
                })
                .finally(function () {
                    self.$set(self.additionalOfficerLoading, index, false);
                });
        },

        debouncedAdditionalLookup(index) {
            if (this.additionalOfficerTimers[index]) {
                clearTimeout(this.additionalOfficerTimers[index]);
            }
            const self = this;
            this.additionalOfficerTimers[index] = setTimeout(function () {
                self.lookupAdditionalOfficer(index);
            }, 600);
        },

        onAdditionalMemberNoChange(index) {
            if (this.isAdmin) {
                this.debouncedAdditionalLookup(index);
            }
        },

        updateAdditionalIdentityField(index, field, value) {
            const officer = this.localClub.additionalOfficers[index];
            if (!officer) return;

            officer[field] = value;
            if (field === 'memberNo') {
                this.onAdditionalMemberNoChange(index);
            }
        }
    },

    watch: {
        'localClub.additionalOfficers': {
            handler(newVal, oldVal) {
                if (!this.isAdmin) return;
                for (let i = 0; i < newVal.length; i++) {
                    const newMemberNo = newVal[i] ? newVal[i].memberNo : '';
                    const oldMemberNo = (oldVal && oldVal[i]) ? oldVal[i].memberNo : '';
                    if (newMemberNo !== oldMemberNo) {
                        this.debouncedAdditionalLookup(i);
                    }
                }
            },
            deep: true
        }
    },

    mounted() {
        if (this.isAdmin) {
            for (let i = 0; i < this.localClub.additionalOfficers.length; i++) {
                if (this.localClub.additionalOfficers[i].memberNo) {
                    this.lookupAdditionalOfficer(i);
                }
            }
        }
    },

    beforeDestroy() {
        const keys = Object.keys(this.additionalOfficerTimers);
        for (let k = 0; k < keys.length; k++) {
            clearTimeout(this.additionalOfficerTimers[keys[k]]);
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/user/dashboard/pages/clubs/register-club/sections/officers-section/officers-section.js